<div class="row">
  <div class="col-lg-12">
    <div class="mb-3">
      <progressbar class="progress" [value]="stacked" [max]="100"></progressbar>
    </div>
  </div>
  <div class="col-lg-12">
    <button type="button" class="btn btn-sm btn-primary" (click)="randomStacked()">Randomize</button>
  </div>
</div>
